var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.623,
    height: 16.121,
    viewBox: "0 0 32.623 16.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3662",
    "data-name": "Group 3662",
    transform: "translate(-1071 -673.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3660",
    "data-name": "Group 3660",
    transform: "translate(1073 677.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M189.289,108.076v2.687m0,2.685v2.687a1.343,1.343,0,0,1-2.686,0h-2.687a6.74,6.74,0,0,1-6.582-5.376h-4.167v-2.687h4.167a6.739,6.739,0,0,1,6.582-5.373H186.6a1.343,1.343,0,0,1,2.686,0v2.685m-4.03,6.721v-5.376h-2.686v5.376Z",
    transform: "translate(-175.166 -105.082)",
    fill: "#29821b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3661",
    "data-name": "Group 3661",
    transform: "translate(1088.5 673.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2-2",
    "data-name": "Subtraction 2",
    d: "M173.166,108.076v2.687m0,2.685v2.687a1.343,1.343,0,1,0,2.686,0h2.687a6.74,6.74,0,0,0,6.582-5.376h4.167v-2.687h-4.167a6.739,6.739,0,0,0-6.582-5.374h-2.687a1.343,1.343,0,0,0-2.686,0v2.685m4.03,6.721v-5.376h2.686v5.376Z",
    transform: "translate(-174.166 -101.358)",
    fill: "#29821b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnected);
export default __webpack_public_path__ + "static/media/connected.e102b3ed5384c740a3058d4dad05cbf4.svg";
export { ForwardRef as ReactComponent };